
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/health-newsletter-subscription",
      function () {
        return require("private-next-pages/health-newsletter-subscription/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/health-newsletter-subscription"])
      });
    }
  